<template>
  <div style="margin: auto;">
    <a href="" style="margin: 2px;" @click.prevent="changeLanguage('sv')"><img src="@/assets/se.svg" alt="Svenska" width="24" style="vertical-align: text-bottom;"></a>
    <a href="" style="margin: 2px;" @click.prevent="changeLanguage('en')"><img src="@/assets/gb.svg" alt="English" width="24" style="vertical-align: text-bottom;"></a>
  </div>
</template>

<script>
import { i18next } from '@/loc'

export default {
  methods: {
    changeLanguage (lng) {
      i18next.changeLanguage(lng)
    }
  }
}
</script>
